module.exports = __webpack_public_path__ + "assets/icon_manage.459cc2a7.svg";